// extracted by mini-css-extract-plugin
module.exports = {"subMenu":"SidebarItemWithSubmenu_subMenu__17Y7C","subMenuItem":"SidebarItemWithSubmenu_subMenuItem__3toKh"};